import { useCallback, useContext, useState } from 'react'

import { Visibility } from 'globalTypes'

import { Trans } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import Button from 'Root/Component/Button'
import { Context as ShareContext } from 'Root/Contexts/Share'
import { isMatching } from 'lib/breakpoint-helper'
import {
  attachTokenInviteToLink,
  copyShareLink,
  fixUrl,
} from 'lib/share-callback'

const canUseNavigatorShare = Boolean(
  typeof window !== 'undefined' &&
    window.navigator.share &&
    window.navigator.canShare
)

const GenerateLink = ({ visibility }: { visibility: Visibility }) => {
  const { i18n } = useLingui()
  const shareData = useContext(ShareContext)
  const isMobile = isMatching('sm', true)
  const [generateLink, setGenerateShareLink] = useState('')
  const [isGeneratingLink, setIsGeneratingLink] = useState(false)
  const allowCopy = visibility === Visibility.public || generateLink.length > 0

  const handleCopyLink = copyShareLink(
    canUseNavigatorShare && isMobile && window.navigator.canShare(shareData),
    shareData,
    visibility === Visibility.public ? shareData.url : generateLink,
    i18n
  )

  const fetchTokenInviteLink = useCallback(async () => {
    setIsGeneratingLink(true)
    try {
      const data = await attachTokenInviteToLink(shareData)

      setGenerateShareLink(fixUrl(data))
    } finally {
      setIsGeneratingLink(false)
    }
  }, [shareData])

  return (
    <span id="generate-link" className="flex flex-col gap-1 sm:flex-row">
      <span className="w-full px-3 py-5 text-gray-400 border-gray-300 rounded-md shadow-sm form-input">
        {visibility === Visibility.public
          ? fixUrl(shareData.url)
          : generateLink}
      </span>
      <span className="inline-flex gap-1 items-center">
        <Button
          variant="neutral"
          size="lg"
          onClick={handleCopyLink}
          disabled={!allowCopy}
        >
          <Trans>Copia link</Trans>
        </Button>

        {visibility != Visibility.public && (
          <Button
            size="lg"
            loading={isGeneratingLink}
            onClick={fetchTokenInviteLink}
          >
            <Trans>Genera link</Trans>
          </Button>
        )}
      </span>
    </span>
  )
}

export default GenerateLink
